export default "__VITE_ASSET__CrZQeEMv__"